import React from "react";
import { IconAlertTriangle } from "@tabler/icons-react";

// ===============================================
// AULAS IMPORTANTES
// ===============================================

const IMPORTANT_COURSES = [
  "Como funcionam as Subcontas",
  "Conexão com o WhatsApp e resolução de problemas",
  "Dicas importantes para criar o agente",
  "Criação de Agentes de IA do Básico ao Avançado",
];

// ===============================================
// LEARNING STEP COMPONENT
// ===============================================

const LearningStep = () => {
  return (
    <>
      <div className="onb-card__header">
        <h2 className="onb-card__title">Aprendizado</h2>
        <p className="onb-card__subtitle">
          Seu ponto de partida antes de usar a plataforma
        </p>
      </div>

      <div className="onb-card__body">
        <p className="onb-card__text">
          Temos aulas objetivas que vão te preparar para usar a plataforma
          com confiança. Estas são as <strong>aulas essenciais</strong>:
        </p>

        <div className="onb-course-list">
          {IMPORTANT_COURSES.map((course, index) => (
            <div key={index} className="onb-course-item">
              <span className="onb-course-item__number">{index + 1}</span>
              <span className="onb-course-item__text">{course}</span>
            </div>
          ))}
        </div>

        <div className="onb-highlight">
          <IconAlertTriangle size={18} className="onb-highlight__icon" />
          <span className="onb-highlight__text">
            Clientes que assistem as aulas antes de configurar têm uma
            experiência significativamente melhor com a plataforma.
          </span>
        </div>
      </div>
    </>
  );
};

export default LearningStep;
